<template>
  <div class="container">
    <h4 class="title is-4">Reports</h4>
    <loading-box v-if="!reportDataLoaded"></loading-box>
    <div v-if="reportDataLoaded">
      <ReportLoader
        title="Total Evaluators"
        :evaluators="report.totalEvaluators"
        exportUrl="evaluations/export-all-users"
      />
      <hr />
      <ReportLoader
        title="Total Evaluators with assignments"
        :evaluators="report.totalEvaluatorsWithAssignments"
        exportUrl="evaluations/export-users-with-assignments"
      />
      <hr />
      <ReportLoader
        title="Evaluators who have logged in once"
        :evaluators="report.usersLoggedIn"
        exportUrl="evaluations/export-users-logged-in"
      />
      <hr />
      <ReportLoader
        title="Evaluators who have not started their assignments"
        :evaluators="report.usersWithNoAssignmentsStarted"
        exportUrl="evaluations/export-users-no-assignments-started"
      />
      <hr />
      <ReportLoader
        title="Evaluators who have started but not completed assignments"
        :evaluators="report.usersWithAnyAssignmentsStarted"
        exportUrl="evaluations/export-users-any-assignments-started"
      />
      <hr />
      <ReportLoader
        title="Evaluators with all assignments completed"
        :evaluators="report.usersWithAllAssignmentsCompleted"
        exportUrl="evaluations/export-users-all-assignments-completed"
      />
      <hr />
      <h4 class="title is-4">Last 10 Evaluations Started</h4>
       <table class="table is-fullwidth is-striped has-background-light">
        <thead>
          <tr>
            <th>Organization Name</th>
            <th class="has-text-left-aligned">Evaluator Name</th>
            <th class="has-text-centered">Date Started</th>
            <th class="has-text-centered">Completed</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="evaluation in evaluations" :key="evaluation.id">
            <td class="fixed-width">
              <router-link
                :to="{ name: 'StaffApplicationReviewDetail', params: { applicationId: evaluation.application.id } }"
                target="_blank"
              >{{ evaluation.application.organizationName }}</router-link>
            </td>
            <td class="has-text-left-aligned">
              <router-link
                :to="{
                  name: 'EvaluatorDetail',
                  params: { evaluatorId: evaluation.evaluator.id },
                }"
                target="_blank"
                >{{ evaluation.evaluator.fullName }}
              </router-link>
            </td>
            <td class="has-text-centered">{{getDate(evaluation.createdAt)}}</td>
            <td class="has-text-centered">
              <i class="fa fa-check" v-if="evaluation.isCompleted"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import store from '@/vuex/store'

import Report from '@/services/reports'

import LoadingBox from '@/components/LoadingBox'
import ReportLoader from '@/components/reports/ReportLoader'
import Evaluation from '@/services/evaluations'

export default {
  components: { LoadingBox, ReportLoader },
  data() {
    console.log("data");
    return {
      report: [],
      reportDataLoaded: false,
      evaluations: [],
      dataLoaded: false,
      applicationFilters: {
        pageSize: 10,
      },
    }
  },
  created() {
    console.log("created");


    let evaluationsPromise = Evaluation.api
        .list({ filters: this.applicationFilters })
        .then(response => {
          this.evaluations = response.results
        console.log("this.evaluations")
        console.log(this.evaluations)
        })
      Promise.all([evaluationsPromise]).then(
        () => {
          this.dataLoaded = true
        },
      )
      //console.log("evaluationsPromise")
      //console.log(evaluationsPromise)


    Report.api
      .retrieveReports()
      .then(data => {
        this.report = data
        this.reportDataLoaded = true
        console.log("this.report")
        console.log(this.report)
      })
      .catch(err => {
        this.$Alert.alert({
          type: 'error',
          message: `Error loading reports`,
          timeout: 6000,
        })
      })
  },
  methods: {
    getDate(thisdate) {
      return moment(String(thisdate)).format('MM/DD/YYYY hh:mm')
    },},
}
</script>

<style scoped></style>
